import React, { useCallback } from 'react';
import { Badge } from 'reactstrap';

function PDFBadge({
  text,
  isDisabled,
  onDisabled,
  isMobile,
  chapterId,
  getPdfByReference,
  PDFUrl,
}) {
  const getBadgeStyles = () => {
    if (isMobile) {
      return {
        color: 'default',
        className: !text ? 'circle' : '',
        pill: true,
      };
    }
    return {
      color: 'outline',
      className: !text
        ? 'circle badge-outline mr-2'
        : 'mr-2 outline badge-outline badge-link',
      pill: false,
    };
  };

  const handleClick = useCallback(
    (url) => {
      if (isDisabled) {
        if (onDisabled) onDisabled();
      } else {
        getPdfByReference({
          url,
          chapterId,
        });
      }
    },
    [isDisabled, onDisabled],
  );

  if (!PDFUrl) return <></>;
  return (
    <Badge {...getBadgeStyles()} onClick={() => handleClick(PDFUrl)}>
      <i className="icon-document_download7" /> {text}
    </Badge>
  );
}

export default PDFBadge;
